<mat-progress-bar
	mode="indeterminate"
	*ngIf="!isDataLoaded"
	class="sdp-progress-bar"
></mat-progress-bar>
<h2>
	{{ "users.title" | translate }}
</h2>
<mat-card class="sdp-administrative-table-card">
	<div class="sdp-section-header-description">
		<h3>{{ "user.samlGrid.title" | translate }}</h3>
		<div class="sdp-button-create-container">
			<!-- 548 TODO fix after downtime-->
			<button
				mat-raised-button
				(click)="createSamlDialog()"
				color="primary"
				class="sdp-button-create"
			>{{ "sdp.label.add" | translate }}</button>
		</div>
	</div>
	<div class="sdp-section-header-description">
		{{ "user.saml.block.1" | translate }}
	</div>
	<sdp-generic-table
		[columnSchema]="samlSchema"
		[tableName]="'SAML'"
		[tableData]="samlData"
		[rows]="5"
	></sdp-generic-table>
</mat-card>
<div class="sdp-user-card-seperator">&nbsp;</div>
<mat-card class="sdp-administrative-table-card">
	<div class="sdp-section-header-description">
		<h3>{{ "user.userGrid.title" | translate }}</h3>
		<div class="sdp-button-create-container">
			<button
				mat-raised-button
				color="primary"
				(click)="createUserDialog()"
				class="sdp-button-create"
			>{{ "sdp.label.add" | translate }}</button>
		</div>
	</div>
	<div class="sdp-section-header-description">
		{{ "user.info.block.1" | translate }}
	</div>
	<sdp-generic-table
		[columnSchema]="userSchema"
		[tableName]="'Users'"
		[tableData]="data"
		[rows]="5"
		[rowSchema]="rowSchema"
	></sdp-generic-table>
</mat-card>